// extracted by mini-css-extract-plugin
export default {"footerOptions":"AppFooter_footerOptions__dT7i9","footerOption":"AppFooter_footerOption__G7py7"};